import { useLazyQuery } from '@apollo/client';
import { QueryResult, Variables } from './types';
import { assignorQuery } from './gql';

export const useAssignorGql = () => {
  const [runAssignorGql, { loading, data, error }] = useLazyQuery<QueryResult, Variables>(assignorQuery, {
    context: {
      headers: {
        userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
      }
    },
    fetchPolicy: 'network-only'
  });

  return {
    runAssignorGql,
    loadingAssignor: loading,
    dataAssignor: data?.getAssignor || [],
    errorAssignor: error
  };
};
